import { render, staticRenderFns } from "./BoxListDialog.vue?vue&type=template&id=f30d3b0e&scoped=true&"
import script from "./BoxListDialog.vue?vue&type=script&lang=js&"
export * from "./BoxListDialog.vue?vue&type=script&lang=js&"
import style0 from "./BoxListDialog.vue?vue&type=style&index=0&id=f30d3b0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30d3b0e",
  null
  
)

export default component.exports